import { render } from "./ForgotPassword.vue?vue&type=template&id=2d73eca8"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d73eca8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d73eca8', __exports__)) {
    console.log('reload')
    api.reload('2d73eca8', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=2d73eca8", () => {
    console.log('re-render')
    api.rerender('2d73eca8', render)
  })

}


export default __exports__